import { NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  InjectionToken,
  signal,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUser, Column, User } from '@fsf/types';
import { LaravelApi } from '@fsf/util';
import { TranslatePipe } from '@ngx-translate/core';
import { query } from '@vortechron/query-builder-ts';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { finalize } from 'rxjs';
export const USER_API = new InjectionToken<LaravelApi<ApiUser>>(
  'laravel.api.users',
);

@Component({
  selector: 'ui-user-table',
  imports: [
    FormsModule,
    TableModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    TagModule,
    MultiSelectModule,
    SelectModule,
    ToastModule,
    TranslatePipe,
    NgClass,
    ToggleSwitchModule,
    MenuModule,
  ],
  templateUrl: './user-table.component.html',
  styleUrl: './user-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MessageService],
})
export class UserTableComponent {
  @ViewChild('filter') filter!: ElementRef;
  #api = inject(USER_API);
  #router = inject(Router);

  isLoading = signal<boolean>(false);
  totalRecords = signal<number>(0);
  users = signal<User[]>([]);
  editedUsers: { [s: string]: User } = {};
  selectedUser!: User | null;

  menuItems: MenuItem[] = [
    {
      label: 'View',
      icon: 'fa fa-search',
      command: () => console.log('View Action'),
    },
    {
      label: 'Delete',
      icon: 'fa fa-times',
      command: () => console.log('Delete Action'),
    },
  ];

  cols: Column[] = User.meta()?.columns ?? [];
  filterFields: string[] = User.meta()?.globalFilterFields ?? [];

  messageService = inject(MessageService);

  matchModes: SelectItem[] = [
    { label: 'Contains', value: 'contains', title: 'TitleContains' },
  ];
  loadData(e: TableLazyLoadEvent) {
    console.log(e);
    // .include('posts', 'comments')
    // .append('fullname', 'ranking')
    // .fields({
    //   posts: ['id', 'name'],
    //   comments: ['id', 'content'],
    // })
    const q = query('');
    // q.fields({ users: ['id', 'name', 'email'] });
    // Pagination
    if (typeof e.rows === 'number' && typeof e.first === 'number') {
      q.param('perPage', `${e.rows}`).page(e.first / e.rows + 1);
    }

    // Filter
    Object.entries(e.filters || {}).map(([field, filters]) => {
      if (filters) {
        const filterValues = (
          filters instanceof Array ? filters : [filters]
        ).reduce(
          (acc, x) => (x.value === null ? acc : [...acc, x.value]),
          [] as string[],
        );
        if (filterValues.length) {
          q.filter(field, filterValues.join(','));
        }
      }
    });

    // Sort
    if (e.multiSortMeta instanceof Array) {
      q.sort(
        ...e.multiSortMeta.map(({ field, order }) =>
          order < 1 ? `-${field}` : field,
        ),
      );
    }

    console.log(q.build());

    this.toggleIsLoading();
    this.#api
      .readMany(q.build())
      .pipe(finalize(() => this.toggleIsLoading()))
      .subscribe({
        next: (result) => {
          console.log(result);
          this.users.set(
            result.data.reduce((acc, user) => {
              const result = User.safeParse(user);
              if (result.success) {
                return [...acc, result.data];
              }
              console.error(result.error);
              return acc;
            }, [] as User[]),
          );
          this.totalRecords.set(result.meta.pagination.total);
        },
        error: (e: HttpErrorResponse) => {
          // TODO: implement signout in @fsf/auth
          if (e.status === 401) {
            // dirty workaround, NEVER EVER DO THIS!!!
            localStorage.clear();
            this.#router.navigateByUrl('/');
          }
        },
      });
  }

  toggleIsLoading() {
    this.isLoading.update((x) => !x);
  }

  onGlobalFilter(table: Table, event: Event) {
    // table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  queryUserData(e: TableLazyLoadEvent) {
    console.log(e);
  }

  clear(table: Table) {
    // table.clear();
    // this.filter.nativeElement.value = '';
  }

  onRowEditInit(user: User) {
    this.editedUsers[user.id as string] = { ...user };
  }

  onRowEditSave(user: User) {
    const data = User.safeEncode(user);
    debugger;
    // if (user.active) {
    //   delete this.editedUsers[user.id as string];
    //   this.messageService.add({
    //     severity: 'success',
    //     summary: 'Success',
    //     detail: 'Product is updated',
    //   });
    // } else {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error',
    //     detail: 'Invalid Price',
    //   });
    // }
  }

  onRowEditCancel(user: User, index: number) {
    this.users.update((users) =>
      users.map((user, idx) =>
        idx === index ? this.editedUsers[user.id as string] : user,
      ),
    );
    delete this.editedUsers[user.id as string];
  }

  getSeverity(status: string) {
    // switch (status) {
    //   case 'INSTOCK':
    //     return 'success';
    //   case 'LOWSTOCK':
    //     return 'warn';
    //   case 'OUTOFSTOCK':
    //     return 'danger';
    //   default:
    //     return 'info';
    // }
  }
}
